export function restoreSigninLocation(user) {
  const returnTo = user?.state?.returnTo;
  let safePath = '/';
  if (typeof returnTo === 'string' && returnTo.startsWith('/')) {
    const target = new URL(returnTo, window.location.origin);
    if (target.origin === window.location.origin) {
      safePath = target.pathname + target.search + target.hash;
    }
  }
  window.history.replaceState({}, document.title, safePath);
  // BrowserRouter is already mounted during the OIDC callback. replaceState
  // alone changes the address bar without notifying its history listener.
  window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
}
